export const VOICES = [
  { id: 'eleven_v4_turbo', label: 'ElevenLabs v4 Turbo', rate: 0.12 },
  { id: 'eleven_flash_v2_5', label: 'ElevenLabs Flash v2.5', rate: 0.12 },
  { id: 'eleven_v3', label: 'ElevenLabs v3 Conversational', rate: 0.12 },
  { id: 'eleven_v4', label: 'ElevenLabs v4', rate: 0.14 },
  { id: 'eleven_multilingual_v2', label: 'ElevenLabs Multilingual v2', rate: 0.14 },
];

export const MODELS = [
  { id: 'sonnet55', label: 'Claude Sonnet 5.5', rate: 0.051 },
  { id: 'opus55', label: 'Claude Opus 5.5', rate: 0.102 },
  { id: 'sonnet45', label: 'Claude Sonnet 4.5', rate: 0.077 },
  { id: 'haiku45', label: 'Claude Haiku 4.5', rate: 0.026 },
  { id: 'gpt4o', label: 'GPT-4o', rate: 0.057 },
  { id: 'gpt4omini', label: 'GPT-4o Mini', rate: 0.0035 },
];

export const CHAT_MODELS = [
  { id: 'sonnet55', label: 'Claude Sonnet 5.5', rate: 0.025 },
  { id: 'opus55', label: 'Claude Opus 5.5', rate: 0.045 },
  { id: 'sonnet5', label: 'Claude Sonnet 5', rate: 0.025 },
  { id: 'sonnet45', label: 'Claude Sonnet 4.5', rate: 0.025 },
  { id: 'haiku45', label: 'Claude Haiku 4.5', rate: 0.01 },
  { id: 'gpt56terra', label: 'GPT-5.6 Terra', rate: 0.03 },
  { id: 'gpt56luna', label: 'GPT-5.6 Luna', rate: 0.03 },
  { id: 'gpt55', label: 'GPT-5.5', rate: 0.03 },
  { id: 'gpt54', label: 'GPT-5.4', rate: 0.025 },
  { id: 'gpt4o', label: 'GPT-4o', rate: 0.025 },
  { id: 'gpt4omini', label: 'GPT-4o Mini', rate: 0.005 },
];

// Typical carrier rates, billed by your own phone provider.
export const COUNTRIES = [
  { id: 'us', label: 'United States', rate: 0.015 },
  { id: 'ca', label: 'Canada', rate: 0.015 },
  { id: 'uk', label: 'United Kingdom', rate: 0.03 },
  { id: 'au', label: 'Australia', rate: 0.04 },
  { id: 'de', label: 'Germany', rate: 0.04 },
  { id: 'fr', label: 'France', rate: 0.04 },
  { id: 'es', label: 'Spain', rate: 0.035 },
  { id: 'it', label: 'Italy', rate: 0.035 },
  { id: 'mx', label: 'Mexico', rate: 0.03 },
  { id: 'in', label: 'India', rate: 0.04 },
  { id: 'jp', label: 'Japan', rate: 0.08 },
  { id: 'ph', label: 'Philippines', rate: 0.18 },
  { id: 'byo', label: 'Bring your own carrier', rate: 0 },
];

export const LINE_PRICE = 8;
export const INCLUDED_LINES = 10;

const fmt = (r) => `$${+r.toFixed(3) === r ? r.toFixed(3) : r.toFixed(4)}`;
export const PRICE_TABS = [
  { id: 'voice', label: 'Voice engine', note: 'Includes speech-to-text, turn-taking and the call platform.', rows: VOICES.map(v => [v.label, `${fmt(v.rate)} / min`]) },
  { id: 'models', label: 'AI models', note: 'Added to the voice engine for every minute of a call. Starting prices shown.', rows: MODELS.map(m => [m.label, `from ${fmt(m.rate)} / min`]) },
  { id: 'chat', label: 'Chat agents', note: 'Price per AI reply on web chat, SMS, WhatsApp, Instagram and Facebook. Pick the model per agent.', rows: [...CHAT_MODELS].sort((a, b) => a.rate - b.rate).map(m => [m.label, `${fmt(m.rate)} / msg`]) },
  { id: 'tools', label: 'Add-on tools', note: 'Optional tools you run on demand. Pay only when you use them.', rows: [['Voice agent text message (SMS sent during a call)', '$0.03 / text'], ['Knowledge Base lookup', '$0.005 / session'], ['Lead Deep Analysis & Proposal', '$0.59 / business'], ['Brand Profile analysis', '$0.20 / analysis'], ['AI Architect agent build', '$0.35 / build'], ['Lead discovery search', 'Free']] },
  { id: 'telephony', label: 'Telephony', note: 'Phone numbers and carrier minutes are billed directly by your own provider. Typical rates:', rows: COUNTRIES.map(c => [c.label, c.rate ? `≈ $${c.rate.toFixed(3)} / min` : 'Your carrier rate']) },
  { id: 'monthly', label: 'Monthly', note: 'No platform fee. Only optional add-ons bill monthly.', rows: [['Platform', 'Included · no monthly fee'], ['Knowledge Base', 'Included · no monthly fee'], ['Sub-accounts & AI agents', 'Unlimited'], [`Concurrent calls`, `${INCLUDED_LINES} free · $${LINE_PRICE} per extra line`]] },
];

export const PAYG_FEATURES = ['Full platform access', 'Call analytics and transcripts', 'Simulation testing', 'Webhooks and API access', `${INCLUDED_LINES} free concurrent calls`, 'Full GoHighLevel integration', 'Onboarding Engine, Leads & Outreach, AI Architect', 'Private community'];
export const ENT_FEATURES = ['Volume pricing that scales with you', 'Done-for-you system build-outs', 'Access to the Voxinity VA pool', 'HIPAA compliance', 'Higher concurrent call capacity', 'Dedicated support & onboarding'];

const Y = true, N = false;
export const COMPARE = [
  { group: 'Voice AI', rows: [['Price', '$0.11–$0.27 / min', 'Custom pricing'], ['Concurrent calls', `${INCLUDED_LINES} included, more on demand`, 'Higher cap, custom']] },
  { group: 'Chat AI', rows: [['Price', '$0.005+ / msg', 'Custom pricing'], ['SMS, web chat, WhatsApp & social channels', Y, Y]] },
  { group: 'Platform', rows: [['Unlimited sub-accounts & agents', Y, Y], ['White-label & client rebilling', Y, Y], ['Full GoHighLevel integration', Y, Y], ['Webhooks and API access', Y, Y], ['Simulation testing', Y, Y], ['Call analytics and transcripts', Y, Y], ['Onboarding Engine, Leads & AI Architect', Y, Y]] },
  { group: 'Services & compliance', rows: [['Done-for-you system build-outs', N, Y], ['VA pool access', N, Y], ['HIPAA compliance', N, Y]] },
  { group: 'Support', rows: [['Private community', Y, Y], ['Dedicated support & onboarding', N, Y]] },
];

export const PILLARS = [
  ['Your brand, front to back', 'White-label dashboard and client portal on your domain, with your logo and colors.'],
  ['Profit on every minute', 'Rebill clients with your own markup. Voxinity handles the metering and the math.'],
  ['Agents built for you', 'AI Architect turns a website into a ready-to-test agent in a single step.'],
  ['Clients find you', 'Leads & Outreach finds businesses, analyzes them and drafts the proposal.'],
  ['Lives inside GoHighLevel', 'Contacts, calendars, notes and workflows stay in sync both ways.'],
  ['Scale without limits', 'Unlimited sub-accounts and agents. Add call lines only when you need them.'],
];

export const FAQ = [
  ['How does billing work?', 'Add balance to your workspace and usage is deducted as it happens. There is no platform fee and no contract.'],
  ['What does the $10 credit cover?', 'Every new workspace gets $10 once — roughly 55 minutes of calls, or hundreds of chat replies — so you can build and test before adding balance.'],
  ['How are call minutes counted?', 'Calls are measured to the second and charged when they end. There is no per-call minimum.'],
  ['Are phone costs included?', 'Phone numbers and carrier minutes are billed directly by your own phone provider. The estimator shows a typical rate so you see the full cost.'],
  ['How do concurrent calls work?', `Every account includes ${INCLUDED_LINES} calls at the same time, shared across all sub-accounts. Add lines for $${LINE_PRICE}/month each. When you're at the limit, outbound calls wait in a queue and dial as soon as a line frees up.`],
  ['Can I charge my clients for usage?', 'Yes. Client rebilling lets you set your own markup per sub-account, and each client sees usage in your branded portal.'],
  ['Can I use my own AI keys?', 'Yes. Connect your own OpenAI or Claude key and pay a small platform fee per reply instead of the standard rate.'],
  ['Which AI models and voices can I use?', 'Claude, GPT and Gemini models, with ElevenLabs voices in many languages. Pick per agent and switch any time.'],
  ['When should I talk to Enterprise?', 'If you run high volume, need more call lines, need HIPAA compliance, or want our team to build and run your system.'],
];
